<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="createTaskModallLabel"
         aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="createTaskModalLabel">{{$t('tasks.editTask')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form @submit="onSave" v-if="!isSaving">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 form-group">
                                <div class="required font-weight-bold">{{$t('tasks.title')}}</div>
                                <div>{{model.title}}</div>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="font-weight-bold">{{$t('tasks.text')}}</div>
                                <div>{{model.text}}</div>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="font-weight-bold">{{$t('tasks.assignees')}}</div>
                                <div v-if="model.savedAssignees">
                                    {{model.savedAssignees.map(el => el.name).join(',')}}
                                </div>
                                <div class="text-warning radio-message mb-2"
                                     v-if="model.typeId === 'individual' && taskType === 'group'">
                                    <i class="fa fa-exclamation-circle"></i>
                                    {{$t('tasks.changeTaskType')}}
                                </div>
                                <CoordinatorsList v-model="model.assignees"></CoordinatorsList>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="font-weight-bold">{{$t('tasks.type')}}</div>
                                <div>{{model.type}}</div>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="required font-weight-bold">{{$t('tasks.priority')}}</div>
                                <NomDropdown :disabled="true" v-model="model.priorityId" type="Приоритет на задача"
                                             fieldName="Приоритет" :required="true"></NomDropdown>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="required font-weight-bold">{{$t('tasks.category')}}</div>
                                <NomDropdown :disabled="true" v-model="model.categoryId" type="Категория на задача"
                                             fieldName="Категория" :required="true"></NomDropdown>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="required font-weight-bold">{{$t('tasks.activity')}}</div>
                                <NomDropdown :disabled="true" v-model="model.activityId" type="Тип дейност"
                                             :fieldName="$t('tasks.activity')" :required="true"></NomDropdown>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="font-weight-bold">{{$t('tasks.deadline')}}</div>
                                <DatePicker :readonly="true"
                                            v-model="model.deadline"
                                            format="dd.MM.yyyy H:mm"
                                            :min="model.deadline || new Date()"
                                            :data-vv-as="$t('tasks.deadline')"
                                            :error="errors.first($t('tasks.deadline'))"
                                            :fieldName="$t('tasks.deadline')"></DatePicker>
                            </div>
                            <div class="col-md-12 bmd-form-group">
                                <div class="font-weight-bold">{{$t('tasks.attachment')}}</div>
                                <div>
                                    <div class="mb-2" v-for="item in model.attachments" :key="_uid+item.fileName">
                                        <file-crud :file="item"
                                                   :showDescription="false"
                                                   :removable="false"
                                                   @removeFile="onRemoveFile"
                                                   :editable="!item.id"
                                                   :type="item.docTypeCode">
                                        </file-crud>
                                    </div>
                                    <div v-if="!model.attachments.length || (model.attachments[model.attachments.length-1].content || model.attachments[model.attachments.length-1].id)">
                                        <button class="btn btn-primary ml-0" @click="addAtachment">
                                            <i class="fa fa-plus"></i>
                                            {{$t('add')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary">{{$t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            {{$t('buttons.cancel')}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from '../datepicker/DateTimePicker';
    import NomDropdown from '../dropdown/NomenclatureDropdown';
    import { File, Task } from '../../models/models';
    import FileCrud from '../common/FileCRUD';
    import CoordinatorsList from '../coordinations/coordinators-list';
    import taskService from '../../services/tasks.service';

    export default {
        components: {
            DatePicker,
            NomDropdown,
            FileCrud,
            CoordinatorsList
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                model: new Task(),
                isSaving: false
            };
        },
        methods: {
            onSearchEnd(data) {
                this.model.assignee = data;
            },
            onSave(e) {
                e.preventDefault();

                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.save();
                    }
                });
            },
            save() {
                this.isSaving = true;
                let data = new FormData();
                data.append('id', this.model.id);
                data.append('typeId', this.taskType);

                // assignees
                for (let index = 0; index < this.model.assignees.length; index++) {
                    const element = this.model.assignees[index];
                    data.append(`assignees[${index}].userId`, element.userId);
                }

                // file
                if (this.model.attachments.length) {
                    for (let index = 0; index < this.model.attachments.length; index++) {
                        const attachment = this.model.attachments[index];
                        if (attachment.id) {
                            data.append(`attachments[${index}].id`, attachment.id);
                        } else {
                            data.append(`files`, attachment.content);
                        }
                    }
                }

                taskService
                    .expand(data)
                    .then(result => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('updateSuccess'),
                            text: ''
                        });
                        this.$emit('updated', this.model);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        });
                    })
                    .then(() => {
                        this.hide();
                    });
            },
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.isSaving = false;
                this.model = new Task();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            removeFile() {
                this.model.attachment.isDeleted = true;
            },
            addAtachment() {
                this.model.attachments.push(new File());
            },
            onRemoveFile(_id) {
                this.model.attachments = this.model.attachments.filter(x => x._id !== _id);
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);

            // let date = new Date();
            // this.model.deadline = new Date(date.setDate(date.getDate() + 7)); //Add 7 days to current date
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Task(this.value);
                    if (this.value && this.value.assignees) {
                        this.model.savedAssignees = _.cloneDeep(this.value.assignees);
                    }
                    this.model.assignees = [];
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            },
            // 'model.assignees'(newVal){
            //     if (this.model.savedAssignees.length == 1 && this.model.assignees.length >0){
            //         this.model.typeId = 'group';
            //     }
            //     else{
            //         this.model.typeId = 'individual';
            //     }
            // }
        },
        computed: {
            taskType() {
                if (this.model.assignees.length > 0) {
                    return 'group';
                } else {
                    return 'individual';
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
